export default {"src":"/_next/static/media/medias.257a5d91.svg","height":75,"width":307,"blurWidth":0,"blurHeight":0};